import {useTheme} from "@mui/material/styles";
import React from "react";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import CCOContainer from "../../fundamentals/CCOContainer";
import Box from "@mui/material/Box";
import useMediaQuery from '@mui/material/useMediaQuery';
import {CmCollectionType} from "../../types";
import C078ViewTypeImageTextCard from "./C078ViewTypeImageTextCard";
import CCOHeadline from "../../fundamentals/CCOHeadline";

export interface Props {
    cmCollection: CmCollectionType
}

function isOdd(number: number) {
    return Math.abs(number % 2) == 1;

}

function C078ViewTypeImageText(props: Props) {
    const theme = useTheme();
    const isWindowSmall = useMediaQuery(theme.breakpoints.down('md'));
    const items = props.cmCollection.items;
    return !items ? null :
        <CCOComponentWrapper background='grey'>
            <CCOHeadline
                metadataId={props.cmCollection.id}
                headline={props.cmCollection?.teaserTitle || ""}
                id={props.cmCollection.id}
                type="componenthead"
                subtext={props.cmCollection?.teaserText?.textAsTree}
                subtextPropertyName={'properties.teaserText'}
                propertyName={'properties.teaserTitle'}
            />
            <CCOContainer background='grey' width='large'>
                {items.map((item, index) => {
                    return <Box key={index} style={{
                        marginTop: index === 0 ? '10px' : '0',
                        marginBottom: index < items.length - 1 ? '30px' : '10px',
                    }}>
                        <C078ViewTypeImageTextCard item={item} headlineType='h3'
                                                   horizontal={!isWindowSmall}
                                                   showHorizontalPictureOnRight={(props.cmCollection.viewtype ===
                                                                                  'imageLeftRight' ||
                                                                                  props.cmCollection.viewtype ===
                                                                                  'c078_view_type_image_text_left_right')
                                                                                 && isOdd(index)}/>
                    </Box>
                })}
            </CCOContainer>
        </CCOComponentWrapper>
}

export default C078ViewTypeImageText;